module.exports = __webpack_public_path__ + "img/666.d46c857c.png";